import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {Title} from '@angular/platform-browser';
import {TldManagerUserService} from "../../../user/services/tld-manager-user.service";
import {whitelistCharacterValidator} from "common-domain";

@Component({
    selector: 'app-reset-password-init',
    templateUrl: './reset-password-init.component.html',
    styleUrls: ['./reset-password-init.component.scss'],
    standalone: false
})
export class ResetPasswordInitComponent implements OnInit {
  emailSent: boolean;
  resetPasswordForm: FormGroup;
  errorMessages: any;

  constructor(private titleService: Title, private formBuilder: FormBuilder, private userService: TldManagerUserService) {
  }

  ngOnInit() {
    this.createForm();
    this.titleService.setTitle('Reset Password');
  }

  onSubmit() {
    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      return;
    }
    const userName = this.resetPasswordForm.getRawValue().userName.trim();
    this.userService.initResetPassword(userName).subscribe(data => {
    }, error => {
      this.errorMessages = error;
    }, () => {
      this.emailSent = true;
    });
  }

  private createForm() {
    this.resetPasswordForm = this.formBuilder.group({
      userName: new FormControl('', [this.trimmedRequiredValidator(), whitelistCharacterValidator, this.validateUsername()]),
    });
  }

  private trimmedRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value == null || value === '') {
        return {required: true};
      }
      if (typeof value === 'string' && value.trim().length === 0) {
        return {required: true};
      }
      return null;
    };
  }

  validateUsername(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const hasAtSymbol = value.indexOf('@') !== -1;
      return hasAtSymbol ? {invalidFormat: true} : null;
    }
  }
}
